// Utility functions for lead calculations

export const calculateLeadValue = (services, lead = null) => {
  // Use persisted value if available
  if (lead && lead.estimated_value !== null && lead.estimated_value !== undefined) {
    return parseFloat(lead.estimated_value) || 0;
  }
  
  // Fallback to dynamic calculation
  if (!Array.isArray(services)) return 0;
  
  return services.reduce((sum, service) => {
    return sum + (parseFloat(service.service_price) || 0);
  }, 0);
};

export const formatCurrency = (amount) => {
  return `$${amount.toLocaleString()}`;
};

export const getLeadValueDisplay = (services, lead = null) => {
  const value = calculateLeadValue(services, lead);
  return value > 0 ? formatCurrency(value) : null;
};

// Today's date (yyyy-MM-dd) on the practice's calendar. "Today" is per
// practice, not the browser's or the server's UTC day.
export const practiceToday = (timeZone, now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);

// True when a date-only value is before the practice's today. With no
// timezone it returns false: we cannot tell, so we do not flag it.
export const isPastDue = (dateStr, timeZone, now = new Date()) => {
  if (!dateStr || !timeZone) return false;
  return dateStr < practiceToday(timeZone, now);
};

// Speed-to-lead: hours between the lead being created and now.
export const hoursSinceCreated = (lead) => {
  if (!lead?.created_at) return null;
  return (Date.now() - new Date(lead.created_at).getTime()) / 3600000;
};
